/* Refonte V4 mobile — coque : en-tête collant qui se range, menu plein écran + recherche instantanée,
   compteur panier, barre promo tournante, pop-up d'accueil peu intrusive.
   API : window.v4Shell = { openMenu(), openSearch(q), closeMenu(), refreshCart(), lock(), unlock() }
   Événements : document 'v4:header' { detail: { hidden, height } } à chaque changement d'état de l'en-tête. */
(function () {
  'use strict';
  var d = document, root = d.documentElement, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var api = w.v4Shell = w.v4Shell || {};

  /* ---------- Modalité clavier (lien d'évitement visible seulement au clavier) ---------- */
  d.addEventListener('keydown', function (e) { if (e.key === 'Tab') root.classList.add('v4-kbd'); });
  d.addEventListener('pointerdown', function () { root.classList.remove('v4-kbd'); }, { passive: true });

  /* ---------- Verrou de défilement (tiroir, pop-up) ---------- */
  var locks = 0;
  api.lock = function () { if (locks++ === 0) root.classList.add('v4-lock'); };
  api.unlock = function () { if (locks > 0 && --locks === 0) root.classList.remove('v4-lock'); };

  /* ---------- En-tête : se range au scroll vers le bas, revient vers le haut ---------- */
  var hd = $('[data-v4-header]');
  var wrap = hd && (hd.closest('.v4-hd-wrap') || hd.parentElement);
  var hdHidden = false, lastY = Math.max(0, w.scrollY), acc = 0, lastH = '', ticking = false;
  if (wrap && hd.classList.contains('v4-hd--overlay')) wrap.classList.add('is-overlay');
  function setHeaderVar() {
    var h = hdHidden ? 0 : Math.max(0, Math.round(hd.getBoundingClientRect().bottom));
    var v = h + 'px';
    if (v !== lastH) {
      lastH = v;
      root.style.setProperty('--v4-header-h', v);
      root.setAttribute('data-v4-hd', hdHidden ? 'hidden' : 'shown');
      d.dispatchEvent(new CustomEvent('v4:header', { detail: { hidden: hdHidden, height: h } }));
    }
  }
  function setHidden(v) {
    if (v === hdHidden) return;
    hdHidden = v;
    hd.classList.toggle('is-hidden', v);
    // libère le focus clavier d'un en-tête rangé
    if (v && hd.contains(d.activeElement)) { hdHidden = false; hd.classList.remove('is-hidden'); }
  }
  function onScroll() {
    ticking = false;
    var y = Math.max(0, w.scrollY), dy = y - lastY;
    lastY = y;
    if (root.classList.contains('v4-lock')) return;
    hd.classList.toggle('is-solid', y > 24);
    if (y < 160) { acc = 0; setHidden(false); }
    else {
      // cumule le déplacement dans un même sens (évite le clignotement sur les petits à-coups)
      acc = (dy > 0) === (acc > 0) ? acc + dy : dy;
      if (acc > 14) setHidden(true);
      else if (acc < -10) setHidden(false);
    }
    setHeaderVar();
  }
  if (hd) {
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    w.addEventListener('resize', function () { lastH = ''; onScroll(); }, { passive: true });
    hd.addEventListener('focusin', function () { setHidden(false); setHeaderVar(); });
    hd.addEventListener('transitionend', setHeaderVar);
    onScroll();
  }

  /* ---------- Menu plein écran ---------- */
  var dr = $('#menu-drawer'), scrim = $('[data-v4-scrim]');
  var opener = null, menuOpen = false;
  if (dr) {
    // Hors du conteneur collant : le tiroir se positionne sur la fenêtre et passe au-dessus des barres des autres zones
    if (scrim) d.body.appendChild(scrim);
    d.body.appendChild(dr);
  }
  var warmed = false;
  function warm() {
    if (warmed || !dr) return; warmed = true;
    $$('img[loading="lazy"]', dr).forEach(function (i) { i.loading = 'eager'; });
  }
  function focusables() {
    return $$('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])', dr)
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function setExpanded(v) { $$('[data-v4-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }
  api.openMenu = function (focusSearch) {
    if (!dr) return;
    warm();
    if (!menuOpen) {
      opener = d.activeElement;
      menuOpen = true;
      var sc = $('[data-v4-scroll]', dr); if (sc) sc.scrollTop = 0;
      dr.classList.add('is-open'); scrim && scrim.classList.add('is-open');
      dr.setAttribute('aria-hidden', 'false');
      setExpanded(true);
      api.lock();
    }
    var input = $('#v4-q', dr);
    setTimeout(function () {
      try {
        if (focusSearch && input) input.focus({ preventScroll: true });
        else dr.focus({ preventScroll: true });
      } catch (e) {}
    }, focusSearch ? 0 : 260);
    if (focusSearch && input) { try { input.focus({ preventScroll: true }); } catch (e) {} }
  };
  api.openSearch = function (q) {
    api.openMenu(true);
    if (q != null) { var i = $('#v4-q'); if (i) { i.value = q; runSearch(); } }
  };
  api.closeMenu = function () {
    if (!dr || !menuOpen) return;
    menuOpen = false;
    dr.classList.remove('is-open'); scrim && scrim.classList.remove('is-open');
    dr.setAttribute('aria-hidden', 'true');
    setExpanded(false);
    api.unlock();
    if (opener && opener.focus && d.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  };
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-v4-menu-open],[data-v4-search-open],[data-v4-menu-close],[data-v4-scrim]');
    if (!t) return;
    if (t.hasAttribute('data-v4-search-open')) { e.preventDefault(); api.openMenu(true); }
    else if (t.hasAttribute('data-v4-menu-open')) { e.preventDefault(); api.openMenu(false); }
    else { e.preventDefault(); api.closeMenu(); }
  });
  // Préchauffe les visuels dès l'intention (doigt posé / survol) ou au repos de la page
  $$('[data-v4-menu-open],[data-v4-search-open]').forEach(function (b) {
    b.addEventListener('pointerdown', warm, { passive: true });
    b.addEventListener('mouseenter', warm, { passive: true });
  });
  w.addEventListener('load', function () {
    var idle = w.requestIdleCallback || function (f) { return setTimeout(f, 2500); };
    setTimeout(function () { idle(warm); }, 4000);
  });
  if (dr) {
    // Panier depuis le menu : on ferme le menu, MoonBundle ouvre son tiroir
    $$('[data-v4-cart-link]', dr).forEach(function (a) { a.addEventListener('click', function () { api.closeMenu(); }); });
    // Lien vers la page courante : simple fermeture
    dr.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (a && a.pathname === location.pathname && !a.search && !a.hash) { setTimeout(api.closeMenu, 60); }
    });
    // Glisser vers la gauche pour fermer
    var sx = 0, sy = 0, dragging = false;
    dr.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; dragging = true; }, { passive: true });
    dr.addEventListener('touchend', function (e) {
      if (!dragging) return; dragging = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (dx < -70 && Math.abs(dy) < 50) api.closeMenu();
    }, { passive: true });
  }
  d.addEventListener('keydown', function (e) {
    if (!menuOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); api.closeMenu(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Recherche instantanée (API Shopify predictive search) ---------- */
  var form = $('[data-v4-search-form]'), q = $('#v4-q');
  var panel = $('#v4-sr'), status = $('[data-v4-sr-status]'), list = $('[data-v4-sr-list]'), cols = $('[data-v4-sr-cols]'), all = $('[data-v4-sr-all]');
  var T = {}; try { T = JSON.parse(($('#v4-shell-i18n') || {}).textContent || '{}'); } catch (e) {}
  // le filtre Liquid « t » échappe le HTML (d&#39;oreiller) : on décode une fois, l'affichage ré-échappe
  var decEl = d.createElement('textarea');
  var dec = function (v) { if (typeof v !== 'string' || v.indexOf('&') < 0) return v; decEl.innerHTML = v; return decEl.value; };
  Object.keys(T).forEach(function (k) {
    if (T[k] && typeof T[k] === 'object') Object.keys(T[k]).forEach(function (j) { T[k][j] = dec(T[k][j]); });
    else T[k] = dec(T[k]);
  });
  var cache = {}, timer = null, ctrl = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hl(title, term) {
    var t = esc(title), k = term.trim(); if (k.length < 2) return t;
    try { return t.replace(new RegExp('(' + esc(k).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); } catch (e) { return t; }
  }
  function cents(v) { var n = parseFloat(v); return isNaN(n) ? null : Math.round(n * 100); }
  function money(c) { return w.rsMoney ? w.rsMoney(c) : (c / 100).toFixed(2) + ' €'; }
  function img(url, wd) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + wd; }
  function priceHtml(p) {
    var min = cents(p.price_min != null ? p.price_min : p.price), max = cents(p.price_max != null ? p.price_max : p.price);
    if (min == null) return '';
    var from = max != null && max > min ? (T.from ? esc(T.from) + ' ' : '') : '';
    var bf = w.rsBF && w.rsBF.phase === 'live' && w.rsBF.pct > 0;
    var ex = dr && dr.getAttribute('data-bf-exclude');
    if (bf && ex && (p.tags || []).indexOf(ex) > -1) bf = false;
    if (bf) {
      // même arrondi que le snippet rs-bf-card-price (présentation de la remise automatique Black Friday)
      var red = Math.floor((min * (100 - w.rsBF.pct) + 50) / 100);
      return '<span class="is-bf">' + from + money(red) + '</span><s>' + money(min) + '</s>';
    }
    var cmp = cents(p.compare_at_price_min || p.compare_at_price_max);
    var showCmp = dr && dr.getAttribute('data-show-compare') === 'true' && cmp && cmp > min;
    return from + money(min) + (showCmp ? '<s>' + money(cmp) + '</s>' : '');
  }
  function render(term, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var prods = res.products || [], colls = res.collections || [];
    panel.hidden = false; dr.classList.add('is-q');
    // Les catégories restent visibles sous les résultats (relance quand il y a peu de pièces) ;
    // en recherche, on masque seulement rassurance / liens / langue pour garder l'écran centré sur la commande.
    dr.classList.toggle('is-searching', prods.length + colls.length > 0);
    var CATS = T.cats || {};
    cols.innerHTML = colls.slice(0, 4).map(function (c) {
      var label = (c.handle && CATS[c.handle]) || c.title;
      return '<li><a class="v4-chip" href="' + esc(c.url) + '">' + esc(label) + '</a></li>';
    }).join('');
    list.innerHTML = prods.map(function (p) {
      var im = p.featured_image && p.featured_image.url || p.image;
      return '<li class="v4-sr__item"><a href="' + esc(p.url) + '">' +
        (im ? '<img class="v4-sr__img" src="' + esc(img(im, 160)) + '" alt="" width="64" height="80" loading="lazy">' : '<span class="v4-sr__img"></span>') +
        '<span class="v4-sr__title">' + hl(p.title, term) + '</span><span class="v4-sr__price">' + priceHtml(p) + '</span></a></li>';
    }).join('');
    var n = prods.length;
    status.textContent = n ? (n === 1 ? (T.one || '') : (T.results || '').replace('{{ count }}', n)) : (T.none || '').replace('{{ terms }}', term);
    all.hidden = false;
    all.href = form.action + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
    all.textContent = (T.all || '').replace('{{ terms }}', term);
  }
  function clearResults() {
    if (!panel) return;
    panel.hidden = true; dr.classList.remove('is-searching', 'is-q');
    list.innerHTML = ''; cols.innerHTML = ''; status.textContent = '';
  }
  function runSearch() {
    if (!q || !dr) return;
    var term = q.value.trim();
    form.classList.toggle('has-q', q.value.length > 0);
    clearTimeout(timer);
    if (term.length < 2) { clearResults(); return; }
    timer = setTimeout(function () {
      if (cache[term]) { render(term, cache[term]); return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = w.AbortController ? new AbortController() : null;
      status.textContent = T.loading || '';
      var url = dr.getAttribute('data-suggest-url') + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor';
      fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (j) { cache[term] = j; if (q.value.trim() === term) render(term, j); })
        .catch(function () {});
    }, 160);
  }
  if (q && form && panel) {
    q.addEventListener('input', runSearch);
    var clr = $('[data-v4-search-clear]', form);
    clr && clr.addEventListener('click', function () { q.value = ''; runSearch(); q.focus(); });
    form.addEventListener('submit', function (e) { if (!q.value.trim()) { e.preventDefault(); q.focus(); } });
  }

  /* ---------- Compteur panier (MoonBundle tient le tiroir) ---------- */
  function setCount(n) {
    $$('[data-v4-cart-count], #cart-count-badge, #sticky-cart-badge, #cart-count-badge-mobile').forEach(function (b) {
      if (b.textContent.trim() !== String(n)) b.textContent = n;
      b.classList.toggle('hidden', !(n > 0));
    });
    var a = $('#cart-drawer-trigger');
    if (a && a.dataset.label == null) a.dataset.label = a.getAttribute('aria-label') || '';
    if (a) a.setAttribute('aria-label', a.dataset.label + (n > 0 ? ' (' + n + ')' : ''));
  }
  api.refreshCart = function () {
    return fetch((w.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; }).catch(function () {});
  };
  d.addEventListener('cart:updated', api.refreshCart);
  d.addEventListener('cart:added', api.refreshCart);
  d.addEventListener('cart:refresh', function () { setTimeout(api.refreshCart, 300); });
  if (!w.__v4FetchWrapped && w.fetch) {
    w.__v4FetchWrapped = true;
    var of = w.fetch;
    w.fetch = function () {
      var a0 = arguments[0], url = a0 && a0.url ? a0.url : a0;
      var res = of.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        res.then(function () { setTimeout(api.refreshCart, 150); }).catch(function () {});
      }
      return res;
    };
  }
  // XHR (certains modules ajoutent au panier en XHR)
  if (w.XMLHttpRequest && !w.__v4XhrWrapped) {
    w.__v4XhrWrapped = true;
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        this.addEventListener('load', function () { setTimeout(api.refreshCart, 150); });
      }
      return oo.apply(this, arguments);
    };
  }
  // retour arrière (bfcache) : le compteur peut être périmé
  w.addEventListener('pageshow', function (e) { if (e.persisted) api.refreshCart(); });

  /* ---------- Barre promo tournante ---------- */
  var bar = $('[data-promo-bar]');
  if (bar) {
    var msgs = $$('.v4-promo__msg', bar), i = 0, tm = null, paused = false;
    var go = function (n) {
      if (msgs.length < 2) return;
      var prev = msgs[i];
      i = (n + msgs.length) % msgs.length;
      prev.classList.remove('is-active'); prev.setAttribute('aria-hidden', 'true'); prev.tabIndex = -1;
      msgs[i].classList.add('is-active'); msgs[i].removeAttribute('aria-hidden'); msgs[i].removeAttribute('tabindex');
    };
    var start = function () { if (reduce || msgs.length < 2) return; clearInterval(tm); tm = setInterval(function () { if (!paused && !d.hidden) go(i + 1); }, 5000); };
    start();
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    var p = $('[data-promo-prev]', bar), nx = $('[data-promo-next]', bar);
    p && p.addEventListener('click', function () { go(i - 1); start(); });
    nx && nx.addEventListener('click', function () { go(i + 1); start(); });
    var tx = 0, ty = 0, moved = false;
    bar.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; moved = false; }, { passive: true });
    bar.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy)) { moved = true; go(dx < 0 ? i + 1 : i - 1); start(); }
    }, { passive: true });
    // un balayage n'est pas un tap sur le lien
    bar.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
  }

  /* ---------- Pop-up d'accueil ---------- */
  var pop = $('[data-v4-pop]');
  if (pop) {
    var KEY = 'rs_welcome_dismissed', DAYS = 30, isOpen = false, shown = false;
    var t0 = Date.now(), maxY = 0, idleT = null, interacted = false;
    var dismissed = function () {
      try {
        var ts = parseInt(localStorage.getItem(KEY), 10);
        if (isNaN(ts)) return false;
        if (Date.now() > ts + DAYS * 864e5) { localStorage.removeItem(KEY); return false; }
        return true;
      } catch (e) { return true; } // stockage indisponible : on ne harcèle pas
    };
    var mark = function () { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} };
    var bfOn = function () { return /^(live|teaser)$/.test(root.getAttribute('data-bf') || ''); };
    var cartOpen = function () {
      var c = $('#moonbundle-cart-drawer .moonbundle-cart-drawer-content');
      if (!c) return false;
      var r = c.getBoundingClientRect();
      return r.width > 0 && r.right > 10 && r.left < w.innerWidth - 10 && getComputedStyle(c).visibility !== 'hidden';
    };
    var busy = function () {
      var a = d.activeElement;
      return menuOpen || root.classList.contains('v4-lock') || cartOpen() || (a && /^(INPUT|SELECT|TEXTAREA)$/.test(a.tagName));
    };
    var blocked = /\/(cart|checkout|account)(\/|$)/.test(location.pathname) || /\/pages\/(contact|wishlist)/.test(location.pathname);
    var panelEl = $('[data-v4-pop-panel]', pop), emailEl = $('#welcome-popup-email', pop), formEl = $('#welcome-popup-form', pop), okEl = $('#welcome-popup-success', pop);
    var lastFocus = null;
    api.popup = {
      open: function (force) {
        if (isOpen || shown && !force) return;
        if (!force && (dismissed() || bfOn() || busy())) return;
        isOpen = shown = true; lastFocus = d.activeElement;
        pop.setAttribute('aria-hidden', 'false');
        pop.classList.add('is-open');
        api.lock();
        // pas de focus automatique sur le champ en mobile (le clavier surgirait) : focus sur le panneau
        setTimeout(function () {
          try {
            if (w.matchMedia('(min-width: 768px)').matches && emailEl) emailEl.focus({ preventScroll: true });
            else if (panelEl) panelEl.focus({ preventScroll: true });
          } catch (e) {}
        }, 330);
      },
      close: function (persist) {
        if (!isOpen) return;
        isOpen = false;
        pop.classList.remove('is-open');
        pop.setAttribute('aria-hidden', 'true');
        api.unlock();
        if (persist !== false) mark();
        if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      }
    };
    $$('[data-v4-pop-close]', pop).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); api.popup.close(true); }); });
    d.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') api.popup.close(true); });
    // glisser la feuille vers le bas pour fermer
    var py = 0, pd = 0;
    panelEl && panelEl.addEventListener('touchstart', function (e) { py = e.touches[0].clientY; pd = 0; }, { passive: true });
    panelEl && panelEl.addEventListener('touchmove', function (e) {
      pd = e.touches[0].clientY - py;
      if (pd > 0 && panelEl.scrollTop <= 0) panelEl.style.transform = 'translateY(' + pd + 'px)';
    }, { passive: true });
    panelEl && panelEl.addEventListener('touchend', function () {
      panelEl.style.transform = '';
      if (pd > 80) api.popup.close(true);
    }, { passive: true });
    formEl && formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (emailEl && emailEl.value || '').trim();
      if (!v || v.indexOf('@') < 1) { emailEl && emailEl.focus(); emailEl && emailEl.setAttribute('aria-invalid', 'true'); return; }
      try { fetch(formEl.action, { method: 'POST', body: new FormData(formEl), headers: { Accept: 'application/json' } }).catch(function () {}); } catch (err) {}
      formEl.hidden = true; if (okEl) okEl.hidden = false;
      mark();
      d.dispatchEvent(new CustomEvent('newsletter:subscribed', { detail: { source: 'welcome_popup' } }));
      setTimeout(function () { api.popup.close(false); }, 2200);
    });

    if (!blocked && !dismissed()) {
      // Déclencheur : lecture réelle (≥ 1,2 écran défilé + ≥ 12 s), puis pause de défilement de 1,2 s
      var tryOpen = function () {
        if (shown || maxY < w.innerHeight * 1.2 || Date.now() - t0 < 12000) return;
        if (busy()) { clearTimeout(idleT); idleT = setTimeout(tryOpen, 2500); return; }
        api.popup.open();
      };
      w.addEventListener('scroll', function () {
        interacted = true;
        maxY = Math.max(maxY, w.scrollY);
        clearTimeout(idleT); idleT = setTimeout(tryOpen, 1200);
      }, { passive: true });
      // Desktop : intention de sortie (souris qui file vers les onglets), après une vraie interaction
      if (w.matchMedia && w.matchMedia('(min-width: 768px) and (hover: hover)').matches) {
        d.addEventListener('pointerdown', function () { interacted = true; }, { passive: true });
        d.addEventListener('mouseout', function (e) {
          if (shown || !interacted || Date.now() - t0 < 6000 || e.relatedTarget || e.clientY > 0) return;
          try { if (sessionStorage.getItem('rs_exit_shown') === '1') return; sessionStorage.setItem('rs_exit_shown', '1'); } catch (er) {}
          api.popup.open();
        });
      }
    }
  }
})();
